import { ListItem, AHIcon, useTheme } from "arkh";
import { FormattedMessage } from "react-intl";
import { Switch } from "react-native";
import { graphql, useFragment, useMutation } from "react-relay";
import { WorkspaceSignalEditMainPushNotification_signalWorkspace$key } from "./__generated__/WorkspaceSignalEditMainPushNotification_signalWorkspace.graphql";
import { WorkspaceSignalEditMainPushNotificationMutation } from "./__generated__/WorkspaceSignalEditMainPushNotificationMutation.graphql";

export function WorkspaceSignalEditMainPushNotification(props: {
  signalWorkspace: WorkspaceSignalEditMainPushNotification_signalWorkspace$key;
  disabled: boolean;
}) {
  const workspaceSignal = useFragment(
    graphql`
      fragment WorkspaceSignalEditMainPushNotification_signalWorkspace on SignalWorkspace {
        id
        sendNotificationAtPublish
        updatedAtDate {
          isoString
          ...FormattedDate
        }
        updatedBy {
          name
          id
        }
      }
    `,
    props.signalWorkspace
  );
  const theme = useTheme();

  const colorProps = {
    activeThumbColor: theme.primary,
    activeTrackColor: theme["track-background"],
    trackColor: theme["border-strong"],
  } as any;

  const [mutate] = useMutation<WorkspaceSignalEditMainPushNotificationMutation>(
    graphql`
      mutation WorkspaceSignalEditMainPushNotificationMutation(
        $id: ID!
        $sendNotificationAtPublish: Boolean!
      ) @raw_response_type {
        signalWorkspace(id: $id) {
          updateNotification(
            sendNotificationAtPublish: $sendNotificationAtPublish
          ) {
            sendNotificationAtPublish
            updatedAtDate {
              ...FormattedDate
            }
            updatedBy {
              name
              id
            }
          }
        }
      }
    `
  );

  const setValue = (val: boolean) => {
    mutate({
      variables: {
        id: workspaceSignal.id,
        sendNotificationAtPublish: val,
      },
      optimisticResponse: {
        signalWorkspace: {
          updateNotification: {
            id: workspaceSignal.id,
            sendNotificationAtPublish: val,
            updatedAtDate: workspaceSignal.updatedAtDate
              ? {
                  ...workspaceSignal.updatedAtDate,
                  __isDate: "UnzonedDate" as const,
                }
              : null,
            updatedBy: workspaceSignal.updatedBy,
          },
        },
      },
    });
  };

  return (
    <ListItem
      color={props.disabled ? "transparent" : "surface-primary"}
      border="border-primary"
      right={
        <Switch
          {...colorProps}
          value={workspaceSignal.sendNotificationAtPublish}
          onValueChange={setValue}
          disabled={props.disabled}
        />
      }
      isLast
      disabled
      left={<AHIcon type="notification" color="darkText" />}
    >
      <ListItem.TitleSecondary>
        <FormattedMessage
          defaultMessage="Send push notification"
          description="Workspace signal edit recipients label"
        />
      </ListItem.TitleSecondary>
    </ListItem>
  );
}
